export default __webpack_public_path__ + "static/media/Img5.d6d6dcd1.png";